"use strict";
var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
Object.defineProperty(exports, "__esModule", { value: true });
exports.Appointment = exports.AppointmentStatus = exports.ConsultationType = void 0;
const tslib_1 = require("tslib");
const typeorm_1 = require("typeorm");
const customer_entity_1 = require("../customers/customer.entity");
const user_entity_1 = require("../users/user.entity");
var ConsultationType;
(function (ConsultationType) {
    ConsultationType["VIDEO"] = "video";
    ConsultationType["PHONE"] = "phone";
    ConsultationType["CLINIC"] = "clinic";
    ConsultationType["OUTLET"] = "outlet";
})(ConsultationType || (exports.ConsultationType = ConsultationType = {}));
var AppointmentStatus;
(function (AppointmentStatus) {
    AppointmentStatus["PAYMENT_PENDING"] = "payment_pending";
    AppointmentStatus["SCHEDULED"] = "scheduled";
    AppointmentStatus["CONFIRMED"] = "confirmed";
    AppointmentStatus["COMPLETED"] = "completed";
    AppointmentStatus["CANCELLED"] = "cancelled";
    AppointmentStatus["RESCHEDULED"] = "rescheduled";
    AppointmentStatus["WALK_IN"] = "walk_in";
})(AppointmentStatus || (exports.AppointmentStatus = AppointmentStatus = {}));
let Appointment = class Appointment {
};
exports.Appointment = Appointment;
tslib_1.__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)(),
    tslib_1.__metadata("design:type", Number)
], Appointment.prototype, "id", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => customer_entity_1.Customer, (c) => c.appointments, { onDelete: 'CASCADE' }),
    tslib_1.__metadata("design:type", typeof (_a = typeof customer_entity_1.Customer !== "undefined" && customer_entity_1.Customer) === "function" ? _a : Object)
], Appointment.prototype, "customer", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => user_entity_1.User),
    tslib_1.__metadata("design:type", typeof (_b = typeof user_entity_1.User !== "undefined" && user_entity_1.User) === "function" ? _b : Object)
], Appointment.prototype, "doctor", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => user_entity_1.User, { nullable: true }),
    tslib_1.__metadata("design:type", typeof (_c = typeof user_entity_1.User !== "undefined" && user_entity_1.User) === "function" ? _c : Object)
], Appointment.prototype, "bookedByAgent", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ type: 'enum', enum: ConsultationType }),
    tslib_1.__metadata("design:type", String)
], Appointment.prototype, "consultationType", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ type: 'enum', enum: AppointmentStatus, default: AppointmentStatus.SCHEDULED }),
    tslib_1.__metadata("design:type", String)
], Appointment.prototype, "status", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)(),
    tslib_1.__metadata("design:type", typeof (_d = typeof Date !== "undefined" && Date) === "function" ? _d : Object)
], Appointment.prototype, "scheduledAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ type: 'boolean', default: false }),
    tslib_1.__metadata("design:type", Boolean)
], Appointment.prototype, "isPriority", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ type: 'decimal', precision: 10, scale: 2, default: 0 }),
    tslib_1.__metadata("design:type", Number)
], Appointment.prototype, "consultationFee", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ type: 'decimal', precision: 10, scale: 2, default: 0 }),
    tslib_1.__metadata("design:type", Number)
], Appointment.prototype, "priorityFee", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ type: 'decimal', precision: 10, scale: 2, default: 0 }),
    tslib_1.__metadata("design:type", Number)
], Appointment.prototype, "totalFee", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ nullable: true }),
    tslib_1.__metadata("design:type", typeof (_e = typeof Date !== "undefined" && Date) === "function" ? _e : Object)
], Appointment.prototype, "paymentRequestedAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ nullable: true }),
    tslib_1.__metadata("design:type", typeof (_f = typeof Date !== "undefined" && Date) === "function" ? _f : Object)
], Appointment.prototype, "paymentReceivedAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ length: 120, nullable: true }),
    tslib_1.__metadata("design:type", String)
], Appointment.prototype, "paymentReference", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ nullable: true }),
    tslib_1.__metadata("design:type", Number)
], Appointment.prototype, "durationMinutes", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ type: 'text', nullable: true }),
    tslib_1.__metadata("design:type", String)
], Appointment.prototype, "agentNotes", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ type: 'text', nullable: true }),
    tslib_1.__metadata("design:type", String)
], Appointment.prototype, "doctorOutcomeNotes", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ type: 'text', nullable: true }),
    tslib_1.__metadata("design:type", String)
], Appointment.prototype, "cancelReason", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ nullable: true }),
    tslib_1.__metadata("design:type", Number)
], Appointment.prototype, "rescheduleFromId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ type: 'text', nullable: true }),
    tslib_1.__metadata("design:type", String)
], Appointment.prototype, "prescription", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ type: 'json', nullable: true }),
    tslib_1.__metadata("design:type", typeof (_g = typeof Array !== "undefined" && Array) === "function" ? _g : Object)
], Appointment.prototype, "prescriptionItems", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ nullable: true }),
    tslib_1.__metadata("design:type", typeof (_h = typeof Date !== "undefined" && Date) === "function" ? _h : Object)
], Appointment.prototype, "closedAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ nullable: true }),
    tslib_1.__metadata("design:type", Number)
], Appointment.prototype, "generatedOrderId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.CreateDateColumn)(),
    tslib_1.__metadata("design:type", typeof (_j = typeof Date !== "undefined" && Date) === "function" ? _j : Object)
], Appointment.prototype, "createdAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.UpdateDateColumn)(),
    tslib_1.__metadata("design:type", typeof (_k = typeof Date !== "undefined" && Date) === "function" ? _k : Object)
], Appointment.prototype, "updatedAt", void 0);
exports.Appointment = Appointment = tslib_1.__decorate([
    (0, typeorm_1.Entity)('appointments')
], Appointment);
